/* Querysleutels van Organisaties en Contacten. Ze beginnen met 'organizations' en
 * 'contacts', zodat wat die sleutels al ververst (het Archief na terugzetten) ook deze
 * lijsten en pagina's ververst. */

import type { QueryClient } from '@tanstack/react-query';

export const ORGANISATIES_SLEUTEL = ['organizations', 'relaties'] as const;
export const CONTACTEN_SLEUTEL = ['contacts', 'relaties'] as const;

export const organisatieSleutel = (id: string | undefined) => [...ORGANISATIES_SLEUTEL, 'pagina', id ?? ''] as const;
export const contactSleutel = (id: string | undefined) => [...CONTACTEN_SLEUTEL, 'pagina', id ?? ''] as const;

/** Na bewerken, aanmaken of archiveren: beide lijsten en alle pagina's opnieuw lezen. */
export function naRelatieWijziging(qc: QueryClient): void {
  qc.invalidateQueries({ queryKey: ['organizations'] });
  qc.invalidateQueries({ queryKey: ['contacts'] });
}
